export default __webpack_public_path__ + "static/media/okrs-teams-icon.71337501.svg";